/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes'
import { Dimensions } from 'react-native'
let { width } = Dimensions.get("window");
export default StyleSheet.create({
  container: {
    width: width,

    minHeight: 100,
   
    backgroundColor: '#FFFFFF',
  },
  endorse: {
    width: 50,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: Fonts.style.color.baseColor,
    borderRadius: 5,
    borderWidth: 1,

    marginRight: 5
  },
  content: {

    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
  },
  leftText: {

  },
  mainTitleContainer: {
    marginLeft: 15,
    marginTop: 10
  },
  mainTitle: {
    fontSize: 14,
    fontFamily: Fonts.style.font.bold,
    color: Fonts.style.color.baseColor
  },

  title: {
    fontSize: 12,
    fontFamily: Fonts.style.font.bold,
    color: `black`
  },
  subTitle: {
    fontFamily: Fonts.style.font.bold,
    color: Fonts.style.color.green,
    fontSize: 12,
    flexWrap: "wrap"

  },
  rightTitle: {
    fontFamily: Fonts.style.font.light,
    color: Fonts.style.color.baseColor,
    fontSize: 14
  },

  bottomBorder: {

    borderBottomWidth: 1,
    borderColor: 'grey'
  },
  left: {
    marginLeft: 10,
    flexDirection: 'row',
    width: width - 110,
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    padding: 5
  },

  right: {
    marginBottom: 0,
    backgroundColor: '#FFFFFF',
 

  },
  image: {
    width: 50,
    height: 50,

    borderColor: Fonts.style.color.baseColor,
    borderWidth: 1
  },



  buttonText: {
    fontFamily: Fonts.style.font.regular,
    color: '#FFFFFF',
    fontSize: 12
  },

  button: {
    width: 90,
    height: 30,
    borderRadius: 3,
    marginRight: 0,
    borderColor: Fonts.style.color.baseColor,
    borderWidth: 1
  },
})
